<template>
  <router-view v-slot="{ Component }" v-if="initFinish">
    <keep-alive :include="['HomeTabs']">
      <component :is="Component"/>
    </keep-alive>
  </router-view>

  <van-skeleton v-if="!initFinish">
    <template #template>
      <div :style="{display: 'flex', width: '100%',height:'100vh',flexDirection:'column'}">
        <van-skeleton-paragraph class="appLaunchSke" style="margin-top: 10px;height:30px;"/>
        <van-skeleton-paragraph class="appLaunchSke" style="width:100%;height:90px;"/>
        <van-skeleton-paragraph class="appLaunchSke" style="height:30px;"/>
        <van-skeleton-paragraph class="appLaunchSke" style="height:50px;"/>
        <van-skeleton-paragraph class="appLaunchSke" style="height:50px;"/>
        <div style="flex: 1; display: flex; flex-direction: column;">
          <van-skeleton-paragraph class="appLaunchSke" style="flex: 1;margin-bottom: 10px;"/>
        </div>
      </div>
    </template>
  </van-skeleton>
  <HTaskRewardDialog/>
  <Game/>
  <GameAlertDialog/>
  <HLoading/>
</template>

<script setup>
  import HLoading from "@/components/utils/HLoading.vue";
  import {emitter, hcf, kDebug, kRelease, log} from "@/components/utils/HComFunctions.js";
  import {setToastDefaultOptions, showToast} from "vant";
  import {SaveEnum,hsp} from "@/components/utils/HSp.js";
  import {enc, MD5} from 'crypto-js';
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import pkg from '../package.json';
  import {useHHttp} from "@/hooks/useHHttp.js";
  import MgSelectLinesLogic from "@/components/utils/HSelectLinesLogic.js";
  import {onBeforeMount} from "vue";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import HTaskRewardDialog from "@/components/utils/HTaskRewardDialog.vue";
  import Game from "@/components/pages/Game.vue";
  import GameAlertDialog from "@/components/pages/GameAlertDialog.vue";
  import {usePingPong} from "@/hooks/useHPingPong.js";
  let useHttp = useHHttp();
  let useComApi = useHComApi();

  let initFinish = ref(false);

  //设置全局提示配置
  setToastDefaultOptions({
    position: 'bottom', // top / middle / bottom
    duration: 2000,
  });
  onBeforeMount(() => {
    // 第一次进入一定进入/home
    // if (performance.getEntriesByType("navigation")[0].type === 'reload' && route.path !== '/home') {
    //   router.replace('/home')
    // }
    //h2d=1&py=eyJ1aWQiOiJhcDAydGVzdG1haW4iLCJhaWQiOiJhcDAyIiwidG9rZW4iOiJhYnFrVFdUNmRjYWRsMWgzcmVDdGNTN05hTmprdy9waUo4bTh1TlpGRzNiMCtWb2lBK29Ga1F0ZUU1K1NoaGJJcklEdUpCQzRpQzdqMTNpODQrNDlEZE5kNU1ldm51ZDlXbjJaS2tDNE1KQkZXVWx1dGNsYkdCT29naFRlUHoyRSJ9#/home
    //init device
    HNewGameUIConfig.setNewGameUITypeByAppId("main");
    let inviteCode = localStorage.getItem("code");
    if (inviteCode != null && inviteCode !== "") {
      hdi.inviteCode = inviteCode;
    }
    let h2d = localStorage.getItem("h2d");
    if (h2d != null && h2d !== "") {
      hdi.h2d = (h2d === "1");
    }
    let isDesktop = localStorage.getItem("desktop");
    if (isDesktop != null && isDesktop !== "") {
      hdi.isRunDesktop = (isDesktop === "1");
    }
    let py = localStorage.getItem("py");
    if (py != null && py !== "") {
      try {
        let dataJson = JSON.parse(atob(decodeURIComponent(py)));
        if (dataJson != null) {
          const userToken = dataJson["token"];
          const userId = dataJson["uid"];
          const appId = dataJson["aid"];
          if (userToken && userId && appId && userToken !== '' && userId !== '' && appId !== '') {
            hsp.setString(SaveEnum.userId, userId);
            hsp.setString(SaveEnum.userToken, userToken);
            HNewGameUIConfig.setNewGameUITypeByAppId(appId);
          }
        }
      } catch (e) {
        showToast("解析数据错误,请联系客服!:" + e.stack)
      }
    }
    hdi.deviceModal = navigator.userAgent;
    hdi.deviceInfo = navigator.userAgent + "|" + navigator.platform + "|" + navigator.language + "|";
    hdi.appVersion = pkg.version;

    switch (hcf.getDeviceType()) {
      case "ios":
        hdi.platTypeNo = 3;
        break;
      case "android":
        hdi.platTypeNo = 4;
        break;
      default:
        hdi.platTypeNo = 5;
        break;
    }
    let randomDid = hsp.getString(SaveEnum.userDid);
    if (randomDid == null) {
      randomDid = MD5(Date.now().toString() + hcf.getRandomString(6)).toString(enc.Hex);
      hsp.setString(SaveEnum.userDid, randomDid);
    }
    hdi.deviceNoChangeId = randomDid;
    hdi.deviceId = randomDid;
    useHttp.initHttp();
    //init line && http
    MgSelectLinesLogic.getInstance(() => {
      //登录
      useComApi.refreshToken();
      useComApi.updateAppConfig(()=>{
        initFinish.value = true;
      });
      //启动心跳
      usePingPong();
    });
  });

  function backgroundCallBackEvent(){
    if (document.hidden) {
      // 用户切到后台，可以在这里做相应处理（如暂停音视频、停止定时器等）
    } else {
      log("从后台切换回来");
      // 用户切回来，可以在这里做相应处理（如恢复音视频、重新启动定时器等）
      useComApi.refreshToken();
    }
  }

  onMounted(() => {
    // 在组件挂载时添加监听事件
    document.addEventListener('visibilitychange', backgroundCallBackEvent);
  });

  // 清理事件监听器
  onUnmounted(() => {
    document.removeEventListener('visibilitychange', backgroundCallBackEvent);
  });


</script>

<style>
  .appLaunchSke{
    background-color: var(--ct-app-launch-color);
  }
  html, body, #app {
    background-color: var(--ct-main-bg-color);
    height: 100%;
    scrollbar-width: none; /* Firefox 隐藏滚动条 */
    -ms-overflow-style: none; /* IE/Edge 隐藏滚动条 */
  }
  body::-webkit-scrollbar {
    display: none; /* Chrome/Safari 隐藏滚动条 */
  }
  :root {
    --van-primary-color: #ff6600; /* 你想设置的主色 */
  }
</style>

